import React from "react"
import { Card } from "react-bootstrap"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { Skeleton } from "shared/ui/skeleton/Skeleton"

import { ProjectTitle } from "entities/projects/ui/project-title/ProjectTitle"

import { useProjectCardContext } from "../ProjectCardContext"

export interface ProjectCardTitleProps extends WithClassName {
  as?: React.ElementType
  showClarificationRequestIndicator?: boolean
}

export const ProjectCardTitle = React.memo(
  ({
    className,
    as,
    showClarificationRequestIndicator
  }: ProjectCardTitleProps) => {
    const { isLoading, model } = useProjectCardContext()
    const project = model?.core.data.project?.data

    if (!project && !isLoading) {
      return null
    }

    return (
      <Card.Title
        as={as}
        className={classNames("project-card__title", className)}
      >
        {project ? (
          <ProjectTitle
            project={project}
            showClarificationRequestIndicator={
              showClarificationRequestIndicator
            }
          />
        ) : (
          <Skeleton />
        )}
      </Card.Title>
    )
  }
)
